import axios from 'axios';
import {userStore} from './stores/UserStore';
import {snackbarStore} from './stores/SnackbarStore';
import {chargeStore} from './stores/ChargeStore';
import {translate} from './util'
import { apiBaseUrl } from './apiBaseUrl';

const baseURL = apiBaseUrl;

const http = axios.create({
  baseURL
});

export {baseURL}

http.interceptors.request.use((config) => {
  const userRoutesPattern = /^\/user\/.*/;
  if (userRoutesPattern.test(config.url)) {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

http.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.code === 'ERR_NETWORK') {
    userStore.logout();
    return Promise.reject(error);
  }

  if (!error.response) {
    snackbarStore.showSnackbar(error.message, 'error');
    return Promise.reject(error);
  }

  const { status, data } = error.response;

  if (status === 403) {
    userStore.logout();
    if (data?.code === 'USER_BANNED' && error.config?.url !== '/login') {
      const reason = String(data.reason || '').trim();
      snackbarStore.showSnackbar(reason ? `账号已被封禁：${reason}` : '账号已被封禁，请联系平台客服', 'error');
    }
    return Promise.reject(error);
  }

  if (status === 405 && data?.error === 'Your subscription has expired.') {
    snackbarStore.showSnackbar('订阅已到期，请续费后继续使用', 'error');
    chargeStore.openChargeDialog(false);
    return Promise.reject(error);
  }

  snackbarStore.showSnackbar(translate(data?.error), 'error');
  return Promise.reject(error);
})
export default http;
